import React from 'react';

import { useSessionContext } from '@components/RepoSessionApp/SessionPage';
import { AskAiSVG } from '@components/svgs';

export const Chapters: React.FC<React.PropsWithChildren<InterviewChapters>> = ({ chapters }) => {
  const { videoPlayerRef } = useSessionContext();

  const handleOnPlayClick = (currentTime: number) => {
    if (videoPlayerRef.current) {
      videoPlayerRef.current.setCurrentTime(currentTime / 1000);
      videoPlayerRef.current.play();
    }
  };

  return (
    <div className='mb-7 text-sm'>
      <div className='flex items-center text-sm text-gray-500'>
        <AskAiSVG className='mr-2' /> Generated by Great Question AI
      </div>
      <div className='my-2'>
        {chapters.map((chapter, index) => {
          return (
            <div
              onClick={() => handleOnPlayClick(chapter.timestamp)}
              key={index}
              className='mb-2 flex cursor-pointer select-none items-center text-indigo-600'
            >
              <div className='mr-3 rounded bg-gray-200 px-2 font-mono' style={{ fontFamily: 'monospace' }}>
                {chapter.time_str}
              </div>
              <div>{chapter.title}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
